
import { Capacitor } from '@capacitor/core';
import { mapGetters, mapMutations } from 'vuex';

export default {
    computed: {
        ...mapGetters('supplier', ['isWhitelabel']),
        ...mapGetters('order', ['address', 'isDelivery']),
        addressStreet() {
            return this.address.address;
        },
        addressZipCity() {
            return `${this.address.postal} ${this.address.city}`;
        },
        isNative() {
            return Capacitor.isNative;
        },
        hasAddresses() {
            return this.loggedInUser && this.loggedInUser.addresses.length;
        },
    },
    methods: {
        ...mapMutations('sheet', ['setSheet']),
        ...mapMutations('modal', ['setModal']),
        openAddressModal() {
            // this.setSheet({ type: 'Address' });
            this.setModal({ type: 'AddressPick' });
        },
    },
};
